import React, { useCallback } from 'react';
import { ListParams } from '../../types/main';
import { SelectProps } from './types';
import UserPermissionService from '../../services/UserPermissionService';
import BaseSearchSelect from './BaseSearchSelect';
import { uniqueList } from '../../views/projects/tab-overview/fields/utils';

const UserPermissionField = (props: SelectProps) => {

  const defaultParams: ListParams = {
    page_size: 10,
    sort_key: 'ref.full_name_first_last',
    sort_dir: 'ASC',
  };

  const searchOptionsHandler = useCallback(async (params: ListParams) => {
    const fetchUsers = await UserPermissionService.list({ ...defaultParams, ...params});

    return uniqueList(fetchUsers.items?.filter((item) => item.ref.user !== null).map((item) => ({
      label: item.ref.user.full_name_first_last,
      id: item.ref.user.id,
    }))) || [];
  }, [defaultParams]);

  return (
    <BaseSearchSelect
      searchOptions={searchOptionsHandler}
      {...props}
    />
  );
};


export default UserPermissionField;
